import ControlButtonLabel from 'components/atoms/control-panel-dropdown-label';
import SmsIcon from 'components/atoms/icons/smsIcon';
import { ModuleType } from 'infrastructure/enums';
import { useTranslation } from 'react-i18next';
import { makeid } from 'utils/helpers/makeid';
import { isPractice } from 'utils/userTypeHelper';

import type { UserType } from 'infrastructure/enums';

const getModule = (isRpm?: boolean) => {
  if (typeof isRpm === 'boolean' && isRpm) return ModuleType.RPM;
  if (typeof isRpm === 'boolean' && !isRpm) return ModuleType.CCM;
  return null;
};

interface Props {
  doctorWorkNumber?: string;
  isAdminPanel: boolean;
  userType: UserType;
  setSmsPopupOpen: (arg: boolean) => void;
  setDoctorSmsPopupOpen?: (arg: boolean) => void;
  setCurrentModule?: (module: ModuleType | null) => void;
}

export const useSmsButtons = ({
  doctorWorkNumber,
  isAdminPanel,
  userType,
  setSmsPopupOpen,
  setDoctorSmsPopupOpen,
  setCurrentModule,
}: Props) => {
  const { t } = useTranslation();

  const smsButtons = [
    {
      id: makeid(5),
      render: true,
      label: (
        <ControlButtonLabel
          title={t('labels.smsPatient')}
          subtitle={t('labels.patient')}
        />
      ),
      handleClick: (isRpm?: boolean) => {
        setSmsPopupOpen(true);
        const module = getModule(isRpm);
        setCurrentModule?.(module);
      },
    },
    {
      id: makeid(5),
      render: doctorWorkNumber && !isPractice(userType) && !isAdminPanel,
      label: (
        <ControlButtonLabel
          title={t('labels.smsDoctor')}
          subtitle={t('labels.doctor')}
        />
      ),
      icon: SmsIcon,
      handleClick: () => {
        setDoctorSmsPopupOpen?.(true);
      },
    },
  ].filter(({ render }) => render);

  return smsButtons;
};
